import React, { useState } from "react";

import { fireOnce, regexTester } from "@ds-developer/frontend";

import { Mileage } from "@hubcapp/types";
import { useTealium } from "@hubcapp/context";

import { UpdateMileageModalStateProviderProps } from "./types";
import UpdateMileageModal from "./UpdateMileageModal";

const StateProvider: React.FC<UpdateMileageModalStateProviderProps> = ({
  onDiscardClick = () => {},
  onSaveClick = () => {},
  mileage,
  registration,
}) => {
  const [updatedMileage, setUpdatedMileage] = useState(mileage);
  const { trackEvent } = useTealium();

  const handleMileageChange = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>) => {
    setUpdatedMileage(
      updatedMileage
        ? {
            ...updatedMileage,
            value: parseInt(value),
          }
        : ({
            value: parseInt(value),
            captureDate: new Date(),
          } as Mileage),
    );
  };

  const handleSaveClick = () => {
    if (updatedMileage) {
      onSaveClick(updatedMileage.value);
    }
  };

  const handleMileageInputClick = () => {
    fireOnce("My Details|Interaction|Mileage", () => {
      trackEvent({
        eventCategory: "My Details",
        eventAction: "Interaction",
        eventLabel: "Mileage",
      });
    });
  };

  return (
    <UpdateMileageModal
      onChange={handleMileageChange}
      onDiscardClick={onDiscardClick}
      onSaveClick={handleSaveClick}
      handleMileageInputClick={handleMileageInputClick}
      mileage={updatedMileage}
      registration={registration}
      disabled={
        !updatedMileage ||
        regexTester(updatedMileage.value.toString(), "[^0-9]")
      }
    />
  );
};

export default StateProvider;
